import { Link } from 'react-router-dom';
import { GitCompare, X } from 'lucide-react';
import { useCompare } from '../contexts/CompareContext';
import { cn } from '../lib/utils';
import { useTranslation } from 'react-i18next';

export function CompareFloatingButton() {
  const { compareItems, compareCount, clearCompare } = useCompare();
  const { i18n } = useTranslation();
  const isRTL = i18n.dir() === 'rtl';

  if (compareCount === 0) return null;

  return (
    <div 
      className={cn(
        "fixed bottom-20 z-40 flex items-center gap-2",
        isRTL ? "left-6" : "right-6"
      )}
      data-testid="compare-floating-widget"
    >
      <button
        onClick={clearCompare}
        className="p-2 bg-gray-800 hover:bg-gray-700 rounded-full text-gray-400 hover:text-white transition-colors"
        title="Effacer la comparaison"
      >
        <X className="w-4 h-4" />
      </button>
      
      <Link
        to="/compare"
        className="flex items-center gap-3 bg-blue-600 hover:bg-blue-700 text-white px-4 py-3 rounded-full shadow-lg transition-all hover:scale-105"
      >
        <GitCompare className="w-5 h-5" />
        <span className="font-medium">
          Comparer ({compareCount})
        </span>
      </Link>
    </div>
  );
}

export default CompareFloatingButton;
